var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-badge',{staticClass:"gl-ml-2",attrs:{"size":"sm","variant":"info"}},[_vm._v("\n  "+_vm._s(_vm.draftsCount)+"\n  "),_c('span',{staticClass:"sr-only"},[_vm._v(" "+_vm._s(_vm.n__('draft', 'drafts', _vm.draftsCount))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }